// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-card {
  display: flex;
  flex-direction: row;
  background: var(--color-parchment-100);
  background-image:
    radial-gradient(
      circle at 20% 30%,
      rgba(139, 69, 19, 0.10) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 80% 70%,
      rgba(160, 82, 45, 0.06) 0%,
      transparent 50%
    ),
    repeating-linear-gradient(
      0deg,
      transparent,
      transparent 2px,
      rgba(139, 69, 19, 0.04) 2px,
      rgba(139, 69, 19, 0.04) 3px
    );
  border: 3px solid var(--color-wood-700);
  border-radius: var(--radius-xl);
  overflow: hidden;
  cursor: pointer;
  transition: transform var(--transition-fast), box-shadow var(--transition-fast),
    border-color var(--transition-fast);
  box-shadow: var(--shadow-card);
}

.game-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-card-hover);
  border-color: var(--color-fire-500);
}

.game-card:active {
  transform: translateY(0);
}

.game-card--embedded {
  cursor: default;
}

.game-card--embedded:hover {
  transform: none;
  box-shadow: var(--shadow-card);
  border-color: var(--color-wood-700);
}

/* Left side — image */
.game-card__image-wrap {
  flex: 0 0 100px;
  width: 100px;
  min-height: 100px;
  background: var(--color-wood-700);
  overflow: hidden;
  border-right: 2px solid var(--color-wood-600);
}

.game-card__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.game-card__image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  background: linear-gradient(135deg, var(--color-wood-800), var(--color-wood-700));
}

/* Right side — content */
.game-card__body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: var(--space-1);
  padding: var(--space-3) var(--space-3);
}

/* Row 1: title + favorite */
.game-card__header {
  display: flex;
  align-items: flex-start;
  gap: var(--space-2);
}

.game-card__title {
  flex: 1;
  min-width: 0;
  font-family: var(--font-heading);
  font-size: var(--font-size-body);
  font-weight: var(--font-weight-bold);
  color: var(--color-fire-600);
  line-height: var(--line-height-body);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.game-card__favorite {
  flex-shrink: 0;
}

/* Row 2: meta info */
.game-card__meta {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  flex-wrap: wrap;
}

.game-card__meta-item {
  font-family: var(--font-body);
  font-size: var(--font-size-body-sm);
  color: var(--color-wood-600);
  line-height: var(--line-height-body-sm);
  white-space: nowrap;
  font-weight: 600;
}

/* Row 3: tags */
.game-card__tags {
  overflow: hidden;
}

@media (max-width: 425px) {
  .game-card__image-wrap {
    flex: 0 0 80px;
    width: 80px;
    min-height: 80px;
  }

  .game-card__image-placeholder {
    font-size: 32px;
  }

  .game-card__body {
    padding: var(--space-2);
    gap: 2px;
  }

  .game-card__title {
    font-size: var(--font-size-body-sm);
    line-height: var(--line-height-body-sm);
  }

  .game-card__meta-item {
    font-size: var(--font-size-caption);
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/games/GameCard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC;;;;;;;;;;;;;;;;;KAiBG;EACH,uCAAuC;EACvC,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf;uCACqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iFAAiF;AACnF;;AAEA,yBAAyB;AACzB;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gCAAgC;EAChC,gCAAgC;EAChC,oCAAoC;EACpC,4BAA4B;EAC5B,oCAAoC;EACpC,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,4BAA4B;EAC5B,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,mCAAmC;IACnC,uCAAuC;EACzC;;EAEA;IACE,mCAAmC;EACrC;AACF","sourcesContent":[".game-card {\n  display: flex;\n  flex-direction: row;\n  background: var(--color-parchment-100);\n  background-image:\n    radial-gradient(\n      circle at 20% 30%,\n      rgba(139, 69, 19, 0.10) 0%,\n      transparent 50%\n    ),\n    radial-gradient(\n      circle at 80% 70%,\n      rgba(160, 82, 45, 0.06) 0%,\n      transparent 50%\n    ),\n    repeating-linear-gradient(\n      0deg,\n      transparent,\n      transparent 2px,\n      rgba(139, 69, 19, 0.04) 2px,\n      rgba(139, 69, 19, 0.04) 3px\n    );\n  border: 3px solid var(--color-wood-700);\n  border-radius: var(--radius-xl);\n  overflow: hidden;\n  cursor: pointer;\n  transition: transform var(--transition-fast), box-shadow var(--transition-fast),\n    border-color var(--transition-fast);\n  box-shadow: var(--shadow-card);\n}\n\n.game-card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-card-hover);\n  border-color: var(--color-fire-500);\n}\n\n.game-card:active {\n  transform: translateY(0);\n}\n\n.game-card--embedded {\n  cursor: default;\n}\n\n.game-card--embedded:hover {\n  transform: none;\n  box-shadow: var(--shadow-card);\n  border-color: var(--color-wood-700);\n}\n\n/* Left side — image */\n.game-card__image-wrap {\n  flex: 0 0 100px;\n  width: 100px;\n  min-height: 100px;\n  background: var(--color-wood-700);\n  overflow: hidden;\n  border-right: 2px solid var(--color-wood-600);\n}\n\n.game-card__image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.game-card__image-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 40px;\n  background: linear-gradient(135deg, var(--color-wood-800), var(--color-wood-700));\n}\n\n/* Right side — content */\n.game-card__body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: var(--space-1);\n  padding: var(--space-3) var(--space-3);\n}\n\n/* Row 1: title + favorite */\n.game-card__header {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-2);\n}\n\n.game-card__title {\n  flex: 1;\n  min-width: 0;\n  font-family: var(--font-heading);\n  font-size: var(--font-size-body);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-fire-600);\n  line-height: var(--line-height-body);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.game-card__favorite {\n  flex-shrink: 0;\n}\n\n/* Row 2: meta info */\n.game-card__meta {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  flex-wrap: wrap;\n}\n\n.game-card__meta-item {\n  font-family: var(--font-body);\n  font-size: var(--font-size-body-sm);\n  color: var(--color-wood-600);\n  line-height: var(--line-height-body-sm);\n  white-space: nowrap;\n  font-weight: 600;\n}\n\n/* Row 3: tags */\n.game-card__tags {\n  overflow: hidden;\n}\n\n@media (max-width: 425px) {\n  .game-card__image-wrap {\n    flex: 0 0 80px;\n    width: 80px;\n    min-height: 80px;\n  }\n\n  .game-card__image-placeholder {\n    font-size: 32px;\n  }\n\n  .game-card__body {\n    padding: var(--space-2);\n    gap: 2px;\n  }\n\n  .game-card__title {\n    font-size: var(--font-size-body-sm);\n    line-height: var(--line-height-body-sm);\n  }\n\n  .game-card__meta-item {\n    font-size: var(--font-size-caption);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
